module.exports = __webpack_public_path__ + "img/visa.21f32e66.png";